import React from 'react';
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import usePDA1080_R01Store from "./usePDA1080_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import PDA1080_R01Form from "./PDA1080_R01Form";
import PDA1080_R01Table from "./PDA1080_R01Table";

/**
 * PDA1080_R01 자재반입 메인 컨테이너
 * 
 * 기능:
 * - 생산 후 잔량 자재를 창고로 반입
 * - LOT 스캔으로 자재 정보 조회
 * - 여러 LOT를 일괄 반입 가능
 * 
 * 화면 구성:
 * - 상단: LOT 스캔 폼 + 자재 정보 + 반입 수량 입력
 * - 하단: 반입 대기 목록 그리드
 */
interface PDA1080_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1080_R01Container = ({ 
  menuNm, 
  menuCd, 
  onBack 
}: PDA1080_R01ContainerProps) => {
  const { loading, reset } = usePDA1080_R01Store();

  const { handleMenuClick } = usePDAContainer(reset);

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      {/* 헤더 */}
      <PDAHeader 
        menuNm={menuNm} 
        menuCd={menuCd} 
        onBack={onBack} 
        onMenuClick={handleMenuClick} 
      />

      {/* 메인 콘텐츠 */}
      <div className="flex-1 overflow-hidden flex flex-col min-h-0">
        {/* 상단: 자재반입 입력 폼 (컴팩트하게) */}
        <div className="flex-none overflow-y-auto">
          <PDA1080_R01Form />
        </div>

        {/* 하단: 반입 대기 목록 테이블 (남은 공간 전부) */}
        <div className="flex-1 min-h-0 overflow-hidden">
          <PDA1080_R01Table />
        </div>
      </div>

      {/* 로딩 스피너 */}
      {loading && <SpinnerOverlay text="처리 중..." />}
    </div>
  );
};

export default PDA1080_R01Container;
